import React from 'react';

import { Button, Stack, TextField } from '@mui/material';

export type CharterSeatSearchProps = {
  pnr: string;
  onPnrChange: (value: string) => void;
  onSearch: () => void;
  isLoading?: boolean;
};

export default function CharterSeatSearch({
  pnr,
  onPnrChange,
  onSearch,
  isLoading,
}: CharterSeatSearchProps): React.JSX.Element {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'flex-end' }}>
      <TextField
        label="Charter PNR"
        value={pnr}
        onChange={(event) => onPnrChange(event.target.value)}
        placeholder="Enter charter PNR"
        sx={{ flex: 1, minWidth: 200 }}
      />
      <Button variant="contained" onClick={onSearch} sx={{ minWidth: 160 }} disabled={isLoading}>
        {isLoading ? 'Searching…' : 'Search'}
      </Button>
    </Stack>
  );
}
